// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/tailplane-icing-avoidance.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/tailplane-icing-avoidance/tailplane-icing-avoidance.js';

mount([g0]);
